<template>
    <div id="listMileageUploadDetail" class="mileage-upload-list">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Mileage Upload Detail List</div>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportMileageDetail()">
                            <i class="fp-export"></i> Export
                        </a>
                        <!-- <button id="removeDiscaredAllBtn" v-on:click.prevent="removeDiscarded('all')" class="btn btn-primary">Remove Discarded</button> -->
                        <router-link class="btn btn-primary" v-bind:to="{name: 'MileageUploadList'}" > <i class="fp-back"> </i> Back</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content vendor-invoice-list">
                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div class="">
                                <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                    <button type="button" id="getWeeklyActive" v-on:click="getWeeklyActive(this)" :class="'btn btn-secondary '+ weeklyActive"> Weekly </button>
                                    <button type="button" id="getMonthlyActive" v-on:click="getMonthlyActive(this)" :class="'btn btn-secondary '+ monthlyActive"> Monthly </button>
                                    <button type="button" id="getOtherActive" v-on:click="getOtherActive(this)" :class="'btn btn-secondary '+ otherActive"> Other </button>
                                </div>
                            </div>
                        </div>
                        <data-table-filter-config :moduleName="'mileageUploadDetailList'" ref="filterMileageUploadDetailList" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                        <section class="bg-white data-table">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'mileageUploadDetailList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    mode="remote"
                                    ref="listMileageDetailTable"
                                    title="Mileage Upload Detail"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    @on-row-click="onActionClick"
                                    :columns="columns"
                                    :rows="rows"
                                    :totalRows="totalRecords"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :search-options="{
                                        enabled: false,
                                        placeholder: 'Search Mileage Upload Detail',
                                    }"
                                    :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :sort-options="{
                                        enabled: true,
                                    }"
                                    :row-style-class="rowStyleClassFn">
                                    <!-- <div slot="emptystate">
                                        No Data Found.
                                    </div> -->
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <template v-if="props.column.field == 'action'">
                                                <template>
                                                    <a href="javascript:void(0);" v-if="flag != 'other'" title="Edit Reading" class="fp-edit" v-on:click.prevent="onCellClick(props)"></a><span v-if="props.row.discarded.toLowerCase() == 'no' && flag != 'other'">&nbsp;|&nbsp;</span>
                                                    <a href="javascript:void(0);" v-if="props.row.discarded.toLowerCase() == 'no' && flag != 'other'" title="View Previous Billed Reading" class="fp-view" id="viewReading"></a>
                                                </template>
                                            </template>
                                            <template v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </template>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions">
                                        <button v-if="flag != 'other'" id="discardedBtn" v-on:click.prevent="undoDiscarded('discard')" class="btn btn-primary">Discard</button>
                                        <button v-if="flag != 'other'" id="undoDiscardedBtn" v-on:click.prevent="undoDiscarded('undo')" class="btn btn-primary">Undo Discarded</button>
                                        <button v-if="flag != 'other'" id="postMileageBtn" v-on:click.prevent="postMileage()" class="btn btn-primary">Post</button>
                                        <button id="removeDiscaredBtn" v-on:click.prevent="removeDiscarded('')" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                        </div>
                        <!-- Update Mileage Modal-->
                        <div class="modal fade invoice-modal mileage-modal" id="mileageModal" ref="mileageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content" style="width:130% !important">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Update Reading</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="mileageForm" class="addinspectionForm telematics-reading-form">
                                            <div class="form-row row-cols-md-3 row-cols-1">
                                                <input class="form-control" id="id" type="hidden" v-model="id">
                                                <div class="col form-group">
                                                    <label class="control-label require" for="name">Asset:</label>
                                                    <input class="form-control" id="unit_no" type="text" v-model="unit_no" disabled='disabled'>
                                                </div>
                                                <div class="col form-group"></div>
                                                <div class="col form-group"></div>
                                                <div class="col form-group">
                                                    <template v-if="odometer_required">
                                                        <label class="control-label require" for="name">Reading</label>
                                                        <input class="form-control" type="text" v-model="odometer" id="odometer" name="odometer" @keypress="isAmountCheck($event)"/>
                                                        <span class="field-error">{{odometer_error_msg}}</span>
                                                    </template>
                                                    <template v-else>
                                                        <label class="control-label" for="name">Reading</label>
                                                        <input class="form-control" type="text" v-model="odometer" id="odometer" name="odometer" disabled/>
                                                    </template>
                                                </div>
                                                <div class="col form-group">
                                                    <template v-if="odometer_required">
                                                        <label class="control-label require" for="name">LTD Reading</label>
                                                        <input class="form-control" type="text" v-model="ltd_odometer" id="ltd_odometer" name="ltd_odometer" @keypress="isAmountCheck($event)"/>
                                                        <span class="field-error">{{ltd_odometer_error_msg}}</span>
                                                    </template>
                                                    <template v-else>
                                                        <label class="control-label" for="name">LTD Reading</label>
                                                        <input class="form-control" type="text" v-model="ltd_odometer" id="ltd_odometer" name="ltd_odometer" disabled/>
                                                    </template>
                                                </div>
                                                <div class="col form-group">
                                                    <template v-if="odometer_required">
                                                        <label class="control-label require" for="name">Reading Date Time:</label>
                                                        <!-- <input class="form-control" type="text" v-model="reading_date" id="reading_date" name="reading_date" disabled='disabled'> -->
                                                        <div class="input-group">
                                                            <date-picker placeholder="MM/DD/YYYY hh:mm:ss a" id="reading_date" name="reading_date" v-model="reading_date" :config="optionsDate" aria-describedby="basic-addon3" class='cal-icon'></date-picker>
                                                            <label for="reading_date" class="fp-calendar input-calender-icon"></label>
                                                        </div>
                                                        <span class="field-error">{{reading_date_error_msg}}</span>
                                                    </template>
                                                    <template v-else>
                                                        <label class="control-label" for="name">Reading Date Time:</label>
                                                        <input class="form-control" type="text" v-model="reading_date" id="reading_date" name="reading_date" disabled='disabled'>
                                                    </template>
                                                </div>

                                                <div class="col form-group">
                                                    <template v-if="reefer_required">
                                                        <label class="control-label require" for="name">Reefer Hrs</label>
                                                        <input class="form-control" type="text" v-model="reefer_hrs" id="reefer_hrs" name="reefer_hrs" @keypress="isAmountCheck($event)"/>
                                                        <span class="field-error">{{reefer_hrs_error_msg}}</span>
                                                    </template>
                                                    <template v-else>
                                                        <label class="control-label" for="name">Reefer Hrs</label>
                                                        <input class="form-control" type="text" v-model="reefer_hrs" id="reefer_hrs" name="reefer_hrs" disabled/>
                                                    </template>
                                                </div>
                                                <div class="col form-group">
                                                    <template v-if="reefer_required">
                                                        <label class="control-label require" for="name">LTD Reading</label>
                                                        <input class="form-control" type="text" v-model="ltd_reefer" id="ltd_reefer" name="ltd_reefer" @keypress="isAmountCheck($event)"/>
                                                        <span class="field-error">{{ltd_reefer_error_msg}}</span>
                                                    </template>
                                                    <template v-else>
                                                        <label class="control-label" for="name">LTD Reading</label>
                                                        <input class="form-control" type="text" v-model="ltd_reefer" id="ltd_reefer" name="ltd_reefer" disabled/>
                                                    </template>
                                                </div>
                                                <div class="col form-group">
                                                    <template v-if="reefer_required">
                                                    <label class="control-label require" for="name">Reefer Hrs Date Time:</label>
                                                    <div class="input-group">
                                                        <date-picker placeholder="MM/DD/YYYY hh:mm:ss a" id="reefer_date" name="reefer_date" v-model="reefer_date" :config="optionsDate" aria-describedby="basic-addon3" class='cal-icon'></date-picker>
                                                        <label for="reefer_date" class="fp-calendar input-calender-icon"></label>
                                                    </div>
                                                    <span class="field-error">{{reefer_date_error_msg}}</span>
                                                    </template>
                                                    <template v-else>
                                                        <label class="control-label" for="name">Reefer Hrs Date Time:</label>
                                                        <input class="form-control" type="text" v-model="reefer_date" id="reefer_date" name="reefer_date" disabled='disabled'>
                                                    </template>
                                                </div>

                                                <div class="col form-group">
                                                    <template v-if="engine_required">
                                                        <label class="control-label require" for="name">Engine Hrs</label>
                                                        <input class="form-control" type="text" v-model="engine_hrs" id="engine_hrs" name="engine_hrs" @keypress="isAmountCheck($event)"/>
                                                        <span class="field-error">{{engine_hrs_error_msg}}</span>
                                                    </template>
                                                    <template v-else>
                                                        <label class="control-label" for="name">Engine Hrs</label>
                                                        <input class="form-control" type="text" v-model="engine_hrs" id="engine_hrs" name="engine_hrs" disabled/>
                                                    </template>
                                                </div>
                                                <div class="col form-group">
                                                    <template v-if="engine_required">
                                                        <label class="control-label require" for="name">LTD Reading</label>
                                                        <input class="form-control" type="text" v-model="ltd_engine" id="ltd_engine" name="ltd_engine" @keypress="isAmountCheck($event)"/>
                                                        <span class="field-error">{{ltd_engine_error_msg}}</span>
                                                    </template>
                                                    <template v-else>
                                                        <label class="control-label" for="name">LTD Reading</label>
                                                        <input class="form-control" type="text" v-model="ltd_engine" id="ltd_engine" name="ltd_engine" disabled/>
                                                    </template>
                                                </div>
                                                <div class="col form-group">
                                                    <template v-if="engine_required">
                                                    <label class="control-label require" for="name">Engine Hrs Date Time:</label>
                                                    <div class="input-group">
                                                        <date-picker placeholder="MM/DD/YYYY hh:mm:ss a" id="engine_date" name="engine_date" v-model="engine_date" :config="optionsDate" aria-describedby="basic-addon3" class='cal-icon'></date-picker>
                                                        <label for="engine_date" class="fp-calendar input-calender-icon"></label>
                                                    </div>
                                                    <span class="field-error">{{engine_date_error_msg}}</span>
                                                    </template>
                                                    <template v-else>
                                                        <label class="control-label" for="name">Engine Hrs Date Time:</label>
                                                        <input class="form-control" type="text" v-model="engine_date" id="engine_date" name="engine_date" disabled='disabled'>
                                                    </template>
                                                </div>

                                                <div class="col-md-12">
                                                    <label class="control-label" for="name">Comment</label>
                                                    <textarea class="form-control" v-model="comment" id="comment" placeholder="Enter Comment" name="comment">
                                                    </textarea>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="modal-footer btm-action-btn-fl">
                                        <button class="btn btn-primary" id="updateMileageButton" v-on:click.prevent="updateMileage()"> <i class="fp-reload"> </i> Update</button>
                                        <button type="button" id="cancelMileageButton" class="btn btn-tertiary" data-dismiss="modal"> <i class="fp-close"> </i> Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
import BillingForecastDetailReportVue from './reports/BillingForecastDetailReport.vue';
export default {
    name: "MileageUploadDetailList",
    metaInfo: {
        title: "Mileage Upload Detail List | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        firstLoad:0,
        loading:false,
        permissions:[],
        cantAccessPage:'',
        columns:[
            {
                label: 'Action',
                field: 'action',
                html: true,
                sortable: false,

            },
            {
                label: 'Asset | Customer',
                field: 'unit_cust_no',
                filterable: true,
                fpFieldType:"text",
                sortable:true
            },
            // {
            //     label: 'Customer',
            //     field: 'cust_name',
            //     filterOptions: {
            //         enabled: true, // enable filter for this column
            //         placeholder: 'Customer', // placeholder for filter input
            //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
            //         filterFn: this.columnFilterFn, //custom filter function that
            //         trigger: 'enter', //only trigger on enter not on keyup
            //     },
            //     sortable:true
            // },
            {
                label: 'Location',
                field: 'location',
                filterable: true,
                fpFieldType:"option",
                sortable:true
            },
            {
                label: 'Pool',
                field: 'asset_pool',
                filterable: true,
                fpFieldType:"option",
                sortable:true
            },
            {
                label: 'Type',
                field: 'asset_type',
                filterable: true,
                fpFieldType:"option",
                sortable:true
            },
            {
                label: 'OOS',
                field: 'out_of_service',
                filterable: true,
                fpFieldType:"option",
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: 'OOS', // placeholder for filter input
                    filterDropdownItems: ['Yes','No'], // dropdown (with selected values) instead of text input
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Reading Date',
                field: 'uploaded_reading_date',
                filterable: true,
                fpFieldType:"date",
                sortable:true
            },
            {
                label: 'Billing Date',
                field: 'billing_date',
                filterable: true,
                fpFieldType:"date",
                sortable:true
            },
            {
                label: 'Uploaded By',
                field: 'uploaded_by',
                filterable: true,
                fpFieldType:"text",
                sortable:true
            },
            {
                label: 'Device',
                field: 'device_type',
                filterable: true,
                fpFieldType:"text",
                sortable:true
            },
            {
                label: 'Contract Type',
                field: 'contract_type',
                filterable: true,
                fpFieldType:"option",
                sortable:true
            },
            {
                label: 'Start Date',
                field: 'start_date',
                filterable: true,
                fpFieldType:"date",
                sortable:true
            },
            {
                label: 'LTD Reading',
                field: 'ltd_reading',
                filterable: true,
                sortable:true,
                type: 'number',
            },
            {
                label: 'Uploaded Odometer',
                field: 'uploaded_odometer',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',
            },
            /*{
                label: 'Curr./Est. Odometer',
                field: 'current_odometer',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',//as per changes by Anthony Herrera
            },*/
            {
                label: 'Prev Odometer',
                field: 'previous_odometer',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',
            },
            {
                label: 'Prev LTD',
                field: 'pre_ltd_reading',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',
            },
            {
                label: 'Odometer Diff',
                field: 'odometer_difference',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',
            },
            {
                label: 'Odometer Avg',
                field: 'customer_odometer_average',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',
            },
            {
                label: 'Reefer LTD',
                field: 'rf_ltd_reading',
                filterable: true,
                sortable:true,
                type: 'number',
            },
            {
                label: 'Uploaded Reefer Date',
                field: 'uploaded_reefer_date',
                filterable: true,
                fpFieldType:"date",
                sortable:true
            },
            {
                label: 'Uploaded Reefer',
                field: 'uploaded_reefer_hrs',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',
            },
            /*{
                label: 'Curr/Est Reefer',
                field: 'current_reefer_hrs',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',//as per changes by Anthony Herrera
            },*/
            {
                label: 'Prev Reefer',
                field: 'previous_reefer_hrs',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',
            },
            {
                label: 'Prev Reefer LTD',
                field: 'pre_rf_ltd_reading',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',
            },
            {
                label: 'Reefer Diff',
                field: 'reefer_hrs_difference',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',
            },
            {
                label: 'Reefer Avg',
                field: 'customer_reefer_hrs_average',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',
            },
            {
                label: 'Uploaded Engine Date',
                field: 'uploaded_engine_date',
                filterable: true,
                fpFieldType:"date",
                sortable:true
            },
            {
                label: 'Engine LTD',
                field: 'en_ltd_reading',
                sortable:true,
                filterable: true,
                type: 'number',
            },
            {
                label: 'Uploaded Engine',
                field: 'uploaded_engine_hrs',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',
            },
            /*{
                label: 'Curr/Est Engine',
                field: 'current_engine_hrs',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',//as per changes by Anthony Herrera
            },*/
            {
                label: 'Prev Engine',
                field: 'previous_engine_hrs',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',
            },
            {
                label: 'Prev Engine LTD',
                field: 'pre_en_ltd_reading',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',
            },
            {
                label: 'Engine Diff',
                field: 'engine_hrs_difference',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',
            },
            {
                label: 'Engine Avg',
                field: 'customer_engine_hrs_average',
                filterable: true,
                fpFieldType:"integer",
                sortable:true,
                type: 'number',
            },
            {
                label: 'Prev Comment',
                field: 'previous_comment',
                filterable: true,
                fpFieldType:"text",
                sortable:true
            },
            {
                label: 'Curr Comment',
                field: 'current_comment',
                filterable: true,
                fpFieldType:"text",
                sortable:true
            },
            {
                label: 'Posted',
                field: 'posted',
                filterable: true,
                fpFieldType:"option",
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: 'Posted', // placeholder for filter input
                    filterDropdownItems: ['Yes','No'], // dropdown (with selected values) instead of text input
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Discarded',
                field: 'discarded',
                filterable: true,
                fpFieldType:"option",
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: 'Discarded', // placeholder for filter input
                    filterDropdownItems: ['Yes','No'], // dropdown (with selected values) instead of text input
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Reason',
                field: 'reason',
                filterable: true,
                fpFieldType:"text",
                sortable:true
            },
        ],
        rows:[],
        totalRecords:0,
        batch:'',
        action:'list',
        isDiscarded:false,
        idArr:[],
        weeklyActive:'active',
        monthlyActive:'',
        otherActive:'',
        flag:'weekly',
        id:0,
        unit_no:"",
        reading_date:"",
        odometer:"",
        ltd_engine:'',
        ltd_odometer:'',
        ltd_engine_error_msg:'',
        ltd_odometer_error_msg:'',
        ltd_reefer:'',
        ltd_reefer_error_msg:'',
        odometer_error_msg:"",
        reading_date_error_msg:"",
        optionsDate: {
            format: 'MM/DD/YYYY hh:mm:ss a',
            useCurrent: false,
            showClose: true,
        },
        reefer_hrs:"",
        reefer_hrs_error_msg:"",
        engine_hrs:"",
        engine_hrs_error_msg:"",
        comment:"",
        odometer_required:false,
        engine_required:false,
        reefer_required:false,
        reefer_date:"",
        reefer_date_error_msg:"",
        engine_date:"",
        engine_date_error_msg:"",
        reqeustSent:0,
        currentReadArr:[],
        currentMileageId:0
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_mileage_upload_detail') {
                    self.cantAccessPage = true;
                }
            });
            if (self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    created: function() {

    },
    mounted: function () {

        var self = this;
        self.getPermissions();
        self.batch = self.$route.params.batch;
        // self.loadList();

        // this.$set(this.columns[0],"thClass","sticky-col");
        // this.$set(this.columns[0],"tdClass","sticky-col");
        // this.$set(this.columns[1],"thClass","sticky-col1");
        // this.$set(this.columns[1],"tdClass","sticky-col1");

    },
    methods: {
        loadList() {
            var self = this;
            $('table tr.invoiceDetails').remove();
            self.loading =  true;
            $.ajax({
                url: process.env.ROOT_API + "/mileage-upload-detail/list",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    batch:self.batch,
                    action:self.action,
                    flag:self.flag
                },
                success: function (data) {
                    self.loading =  false;
                    if (self.action == "list") {
                        if (data.status == "success") {
                            if (data.content.row != undefined) {
                            self.rows = data.content.row;
                          }
                            self.totalRecords = data.content.totalRecords;
                        }
                    }else{
                        //export
                        self.action = "list";
                        if ( data.code == "201" ) {
                            alert(data.message);
                        } else {

                            self.excel = data.content.web;
                            var save = document.createElement("a");
                            save.href = self.excel;
                            save.download = data.content.web;
                            save.target = "_blank";

                            document.body.appendChild(save);
                            save.click();
                            document.body.removeChild(save);
                            self.loadList();
                        }
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading =  false;
                    self.generateStatusCodeMessage(jqXHR, false, 'mileage-upload-detail-list')
                }
            });
        },
        selectionChanged:function(param){
            var self = this;
            self.serverParams.selectedAll = false;
            if(param.selectedRows.length == 100) {
                EventBus.$emit('clear-selection', false);
            } else {
                EventBus.$emit('clear-all-flags', false);
            }
            return;
        },
        removeDiscarded(flag) {
            var self = this;
            var message = "Are you sure that you want to delete selected records?";
            if (flag != "" && flag == "all") {
                message = "Are you sure that you want to remove Discarded Records?";
            }
            if (confirm(message)) {
                self.idArr = [];
                //remove discarded clicked
                if (flag != "" && flag == "all") {
                    for(var i = 0;i < self.rows.length; i++){
                        if (self.rows[i] != null) {
                            if (self.rows[i].discarded != undefined && self.rows[i].discarded != null) {
                                if (self.rows[i].discarded.toLowerCase() == "yes") {
                                    self.idArr.push(self.rows[i].id);
                                }
                            }
                        }
                    }
                    if (!self.idArr.length) {
                        self.$swal('','Records with Discarded Not Found.','info');
                        return;
                    }
                }else{
                    //remove selected records
                    var data = this.$refs['listMileageDetailTable'].selectedRows;
                    for(var i = 0;i < data.length; i++){
                        if (data[i] != null) {
                            self.idArr.push(data[i].id);
                        }
                    }
                }
                var currentActive = '';
                if (self.weeklyActive == 'active'){
                    currentActive = 'weekly';
                }
                if (self.monthlyActive == 'active'){
                    currentActive = 'monthly';
                }
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/mileage-upload-detail/remove-discarded",
                    type: "POST",
                    data: {arr:self.idArr,all:self.serverParams.selectedAll,current_active:currentActive,batch:self.batch},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {
                            self.$swal('','Records Removed Successfully.','success');
                            self.$refs.filterMileageUploadDetailList.clearSelectAll();
                            self.loadList();
                        }else{

                        }
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-change-status');
                    }
                });
            }

        },
        rowStyleClassFn: function(row) {
            if(row.discarded.toLowerCase() == 'yes') {
                if (row.reason.toLowerCase().includes('exception')) {
                    return 'exception-row';
                }else if (row.reason.toLowerCase().includes('duplicate') || row.reason.toLowerCase().includes('discarded')) {
                    return 'duplicate-row';
                }else if (row.reason.toLowerCase().includes('customer')){
                    return 'exception-row';
                }else if (row.reason.toLowerCase().includes('negative')){
                    return 'exception-row';
                }else if (row.discarded == 'Yes'){
                    return 'exception-row';
                }
            }
        },
        getWeeklyActive() {
            var self = this;
            self.weeklyActive = 'active';
            self.monthlyActive = '';
            self.otherActive = '';
            self.flag = 'weekly';
            self.loadList();
        },
        getMonthlyActive() {
            var self = this;
            self.weeklyActive = '';
            self.monthlyActive = 'active';
            self.otherActive = '';
            self.flag = 'monthly';
            self.loadList();
        },
        getOtherActive() {
            var self = this;
            self.weeklyActive = '';
            self.monthlyActive = '';
            self.otherActive = 'active';
            self.flag = 'other';
            self.loadList();
        },
        onCellClick(params){
            var self = this;
            //warn if record already discarded
            // if (params.row.discarded.toLowerCase() == "yes") {
            //     self.$swal('',"Record Already Discarded.",'info');
            //     return;
            // }else{
                self.reading_date_error_msg = "";
                self.odometer_error_msg = "";
                self.reefer_hrs_error_msg = "";
                self.engine_hrs_error_msg = "";
                self.reefer_date_error_msg = "";
                self.engine_date_error_msg = "";
                self.reading_date = "";
                self.reefer_date = "";
                self.engine_date = "";
                self.odometer_required = false;
                self.reefer_required = false;
                self.engine_required = false;
                self.id = params.row.id;
                self.unit_no = params.row.unit_no;
                var billingDateTime = "";
                if (params.row.billing_date_time != null && params.row.billing_date_time != "") {
                    billingDateTime = params.row.billing_date_time;
                }
                if (params.row.reading_date_time != null && params.row.reading_date_time != "") {
                    if (billingDateTime != "") {
                        self.reading_date = billingDateTime;
                    }else{
                        self.reading_date = params.row.reading_date_time;
                    }
                }
                if (params.row.current_odometer_reading != undefined) {
                    self.odometer = params.row.current_odometer_reading;
                }else{
                    self.odometer = params.row.current_odometer;
                }
                if (params.row.current_odometer != "") {
                    self.odometer_required = true;
                }
                self.ltd_odometer = params.row.ltd_reading;
                self.reefer_hrs = params.row.current_reefer_hrs;
                if (params.row.current_reefer_hrs != "") {
                    self.reefer_required = true;
                }

                self.ltd_reefer = params.row.rf_ltd_reading;
                self.ltd_engine = params.row.en_ltd_reading;

                self.engine_hrs = params.row.current_engine_hrs;
                if (params.row.current_engine_hrs != "") {
                    self.engine_required = true;
                }
                self.comment = params.row.current_comment;
                if (params.row.current_reefer_date != null && params.row.current_reefer_date != "") {
                    if (billingDateTime != "") {
                        self.reefer_date = billingDateTime;
                    }else{
                        self.reefer_date = params.row.current_reefer_date;
                    }
                }
                if (params.row.current_engine_date != null && params.row.current_engine_date != "") {
                    if (billingDateTime != "") {
                        self.engine_date = billingDateTime;
                    }else{
                        self.engine_date = params.row.current_engine_date;
                    }
                }
                if (params.row.asset_type != null && params.row.asset_type != "") {
                    if (params.row.asset_type.toLowerCase() == "yard") {
                        self.reading_date = "";
                        self.reefer_date = "";
                    }
                }
                $("#mileageModal").modal('show');
            // }
        },
        updateMileage() {
            var self = this;
            var error = false;
            self.reading_date_error_msg = "";
            self.odometer_error_msg = "";
            self.reefer_hrs_error_msg = "";
            self.engine_hrs_error_msg = "";
            self.reefer_date_error_msg = "";
            self.engine_date_error_msg = "";

            if (self.odometer_required) {
                if(!self.reading_date || self.reading_date == '' ||  self.reading_date == null){
                    self.reading_date_error_msg = "Reading Date Required.";
                    error = true;
                }
                if(!self.odometer || self.odometer == ''){
                    self.odometer_error_msg = "Reading Required.";
                    error = true;
                }
                if(!self.ltd_odometer || self.ltd_odometer == ''){
                    self.ltd_odometer_error_msg = "LTD Reading Required.";
                    error = true;
                }
            }

            if (self.reefer_required) {
                if(!self.reefer_date || self.reefer_date == '' ||  self.reefer_date == null){
                    self.reefer_date_error_msg = "Reefer Hrs Date Required.";
                    error = true;
                }
                if(!self.reefer_hrs || self.reefer_hrs == ''){
                    self.reefer_hrs_error_msg = "Reefer Hrs Required.";
                    error = true;
                }
                if(!self.ltd_reefer || self.ltd_reefer == ''){
                    self.ltd_reefer_error_msg = "LTD Reading Required.";
                    error = true;
                }
            }

            if (self.engine_required) {
                if(!self.engine_date || self.engine_date == '' ||  self.engine_date == null){
                    self.engine_date_error_msg = "Engine Hrs Date Required.";
                    error = true;
                }
                if(!self.engine_hrs || self.engine_hrs == ''){
                    self.engine_hrs_error_msg = "Engine Hrs Required.";
                    error = true;
                }
                if(!self.ltd_engine || self.ltd_engine == ''){
                    self.ltd_engine_error_msg = "LTD Reading Required.";
                    error = true;
                }
            }
            var currentActive = '';
            if (self.weeklyActive == 'active'){
                currentActive = 'week';
            }
            if (self.monthlyActive == 'active'){
                currentActive = 'month';
            }
            console.log(self.reefer_date);
            console.log(self.engine_date);

            if (!error) {

                $('#updateMileageButton').text('Updating...');
                $('#updateMileageButton').prop('disabled',true);
                $('#cancelMileageButton').prop('disabled',true);
                $.ajax({
                    url: process.env.ROOT_API + "/mileage-upload-detail/update",
                    type: "POST",
                    data: {id: self.id,reading:self.odometer,
                        reading_date:self.reading_date,comment:self.comment,
                        reefer_hrs:self.reefer_hrs,engine_hrs:self.engine_hrs,
                        reefer_date:self.reefer_date,engine_date:self.engine_date,
                        ltd_odometer:self.ltd_odometer,ltd_engine:self.ltd_engine,ltd_reefer:self.ltd_reefer,currentActive:currentActive},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $('#updateMileageButton').text('Update');
                        $('#updateMileageButton').prop('disabled',false);
                        $('#cancelMileageButton').prop('disabled',false);
                        if(data.code == 201){
                            self.$swal('',data.message,'info');
                            return;
                        }
                        if (data.status == "success") {
                            $("#mileageModal").modal('hide');
                            self.loadList();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $('#updateMileageButton').text('Update');
                        $('#updateMileageButton').prop('disabled',false);
                        $('#cancelMileageButton').prop('disabled',false);
                        $("#mileageModal").modal('hide');
                        self.generateStatusCodeMessage(jqXHR, true, 'mileage-upload-update')
                    }
                });
            }
        },
        postMileage() {
            var self = this;
            var error = false;
            var validateArr = [];
            self.idArr = [];
            var data = this.$refs['listMileageDetailTable'].selectedRows;
            for(var i = 0;i < data.length; i++){
                if (data[i] != null) {
                    self.idArr.push(data[i].id);
                    validateArr.push(data[i].discarded.toLowerCase());
                }
            }
            var currentActive = '';
            if (self.weeklyActive == 'active'){
                currentActive = 'weekly';
            }
            if (self.monthlyActive == 'active'){
                currentActive = 'monthly';
            }

            //check all values in array are equal or not
            const allEqual = arr => arr.every( v => v === arr[0] );
            var found = allEqual(validateArr);
            if ( found ) {
                if (validateArr[0] == "no") {
                    error = false;
                }else{
                    error = true;
                }
            }else{
                error = true;
            }
            //allow to post records with discarded no
            if (error) {
                self.$swal({
                    title: "",
                    text: "Discarded records will be skipped",
                    type: "warning",
                    confirmButtonText: "Ok",
                    cancelButtonText: "Cancel",
                    showCloseButton: true,
                    showLoaderOnConfirm: false,
                    showCancelButton:true,
                    allowOutsideClick:false
                }).then(result => {
                    if (result.value) {

                        self.loading = true;
                        $.ajax({
                            url: process.env.ROOT_API + "/mileage-upload-detail/post",
                            type: "POST",
                            data: {arr:self.idArr,all:self.serverParams.selectedAll,current_active:currentActive,batch:self.batch},
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                self.loading = false;

                                if (data.status == "success") {
                                    self.$swal('','Records Posted Successfully.','success');
                                    self.$refs.filterMileageUploadDetailList.clearSelectAll();
                                    self.loadList();
                                    EventBus.$emit('clear-all-flags', false); 
                                }else{

                                }
                            },
                            error: function (jqXHR, exception) {

                                self.loading = false;
                                self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-change-status');
                            }
                        });
                        
                    } else if (result.dismiss == 'cancel') {
                        return;
                    }else if(result.dismiss == 'close'){
                        return;
                    }
                });
                // self.$swal('',"Discarded records will be skipped.",'info');
                // return;
            }else{
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/mileage-upload-detail/post",
                    type: "POST",
                    data: {arr:self.idArr,all:self.serverParams.selectedAll,current_active:currentActive,batch:self.batch},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {
                            self.$swal('','Records Posted Successfully.','success');
                            self.$refs.filterMileageUploadDetailList.clearSelectAll();
                            self.loadList();
                            EventBus.$emit('clear-all-flags', false); 
                        }else{

                        }
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-change-status');
                    }
                });
            }

            
        },
        undoDiscarded(type) {
            var self = this;
            var error = false;
            var vehicleIdArr = [];
            var discardedArr = [];
            self.idArr = [];
            var data = this.$refs['listMileageDetailTable'].selectedRows;
            for(var i = 0;i < data.length; i++){
                if (data[i] != null) {
                    self.idArr.push(data[i].id);
                    vehicleIdArr.push(data[i].vehicle_id);
                    discardedArr.push(data[i].discarded.toLowerCase());
                }
            }

            var checkDuplicateVal = self.checkDuplicate(vehicleIdArr);
            if (checkDuplicateVal) {
                self.$swal('',"Please select Records with Different Asset.",'info');
                return;
            }

            //check all values in array are equal or not
            const allEqual = arr => arr.every( v => v === arr[0] );
            var found = allEqual(discardedArr);
            if ( found ) {
                if (type == "undo") {
                    //undo discard from discarded Yes to No
                    if (discardedArr[0] == "yes") {
                        error = false;
                    }else{
                        error = true;
                    }
                }
                else{
                    //discard from discarded No to Yes
                    if (discardedArr[0] == "no") {
                        error = false;
                    }else{
                        error = true;
                    }
                }
            }else{
                error = true;
            }

            if (type == "undo") {
                //undo discard from discarded Yes to No
                //check whether all selected records are with discarded Yes
                if (error && (!found || (found && discardedArr[0] == "no"))) {
                    self.$swal('',"Please select Records with Discarded Yes.",'info');
                    return;
                }
            }else{
                //discard from discarded No to Yes
                //check whether all selected records are with discarded Yes
                if (error && (!found || (found && discardedArr[0] == "yes"))) {
                    self.$swal('',"Please select Records with Discarded No.",'info');
                    return;
                }
            }

            if (!error) {

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/mileage-upload-detail/undo-discarded",
                    type: "POST",
                    data: {arr:self.idArr,type:type},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {
                            if (type == "discard") {
                                self.$swal('','Records Discarded Successfully.','success');
                            }else{
                                self.$swal('','Discarded Records Undo Successfully.','success');
                            }
                            self.loadList();
                        }else{

                        }
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'mileage-undo-discarded');
                    }
                });
            }

        },
        checkDuplicate(arr) {
            var sorted_arr = arr.slice().sort();
            var results = [];
            var found = false;
            for (var i = 0; i < sorted_arr.length - 1; i++) {
                if (sorted_arr[i + 1] === sorted_arr[i]) {
                    results.push(sorted_arr[i]);
                }
            }
            if (results.length > 0) {
                found = true;
            }
            return found;
        },
        exportMileageDetail() {
            var self = this;
            self.action = "export";
            self.loadList();
        },
        onActionClick(params) {
            var self = this;
            var cellEvent = params;
            if (params.event.target.id != undefined && params.event.target.id != null){
                if (params.event.target.id == "viewReading") {
                    self.readingDetails(cellEvent);
                }
            }
        },
        readingDetails(params) {
            var self = this;
            if ( $(params.event.target).hasClass("vgt-checkbox-col") || $(params.event.target).hasClass("glyphicon glyphicon-eye-open")) {
                return;
            }
            if ( self.reqeustSent == 1 ) {
                return;
            }

            //if data already available than remove it
            if ($(params.event.target.closest('.clickable')) != null) {
                if ($(params.event.target.closest('.clickable').nextSibling) != null) {
                    if ( $(params.event.target.closest('.clickable').nextSibling).hasClass("invoiceDetails")) {
                        self.currentReadArr = [];
                        $(params.event.target.closest('.clickable').nextSibling).remove();//table 1
                        $(params.event.target.closest('.clickable').nextSibling).remove();//line
                        $(params.event.target.closest('.clickable').nextSibling).remove();//table 2
                        return;
                    }
                }
            }

            //generate html
            var html = '<tr class="invoiceDetails"><td colspan="8"><table aria-describedby="table" class="table ml-4">';

            var fields = {
                vehicle_id:params.row.vehicle_id,
                customer_id:params.row.customer_id,
                type:params.row.con_type,
                id:params.row.id
            };
            self.reqeustSent = 1;
            self.loading = true;
            self.currentMileageId = params.row.id;

            $.ajax({
                url: process.env.ROOT_API + "/mileage-upload/previous-billed",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.reqeustSent = 0;
                    self.loading = false;
                    if ( data.code == 200 ) {

                        self.currentReadArr = [];
                        //readings allowed to select
                        html += '<tr><th width="10%">&nbsp;</th><th>Reading Date</th><th class="text-right">Reading</th><th>LTD Reading</th><th>Section</th><th>Source</th><th>Is Billing</th><th>Input By</th><th>Device Name</th></tr>';
                        if (data.content.reading.length > 0) {
                            var readArr = data.content.reading;
                            for ( var j=0; j< readArr.length; j++ ) {
                                html += '<tr><td width="10%"><input type="radio" class="checkbox cb-value" id="reading'+readArr[j].id+'" read_value="'+readArr[j].reading+'" section="'+readArr[j].section_name+'" read_date="'+readArr[j].utc_read_date+'" index="'+j+'"/></td><td>'+readArr[j].reading_date+'</td><td class="text-right">'+ readArr[j].reading +'</td><td>'+readArr[j].ltd_reading+'</td><td>'+readArr[j].section_name+'</td><td>'+readArr[j].source+'</td><td>'+readArr[j].is_billing+'</td><td>'+readArr[j].input_by+'</td><td>'+readArr[j].device_type+'</td></tr>';
                                self.currentReadArr.push(readArr[j]);
                            }
                        }else{
                            html += '<tr><td colspan="7">No record found.</td></tr>';
                        }
                        html += '</table></td></tr>';
                        html += '<tr class="invoiceDetails"><td colspan="8"><hr class="light-hr"/></td></tr>';

                        html += '<tr class="invoiceDetails"><td colspan="8"><table aria-describedby="table" class="table ml-4">';
                        if (data.content.flag == "invoice") {
                            html += '<tr><th>Invoice#</th><th>Invoice Date</th><th>Type</th><th>From Date</th><th>To Date</th><th class="text-right">Reading From</th><th class="text-right">Reading To</th><th class="text-right">Diff</th><th class="text-right">Billed Amount</th></tr>';
                        }else{
                            if (data.content.flag == "agreement") {
                                html += '<tr><th>Agreement#</th><th>Type</th><th>Reading Date</th><th class="text-right">Reading</th></tr>';
                            }else if (data.content.flag == "contract") {
                                html += '<tr><th>Contract#</th><th>Type</th><th>Reading Date</th><th class="text-right">Reading</th><th class="text-right">Estimate</th><th class="text-right">Frequency(In Months)</th></tr>';
                            }
                        }
                        //check data records
                        if ( data.content.detail.length > 0 ) {
                            var detailArr = data.content.detail;
                            for ( var j=0; j< detailArr.length; j++ ) {
                                if (data.content.flag == "invoice") {
                                    html += '<tr><td>'+detailArr[j].inv_number+'</td><td>'+detailArr[j].inv_date+'</td><td>'+ detailArr[j].type +'</td><td>'+detailArr[j].reading_from_date+'</td><td>'+detailArr[j].reading_to_date+'</td><td class="text-right">'+detailArr[j].reading_from+'</td><td class="text-right">'+detailArr[j].reading_to+'</td><td class="text-right">'+detailArr[j].billed_qty+'</td><td class="text-right">'+detailArr[j].billed_amount+'</td></tr>';
                                }else{
                                    if (data.content.flag == "agreement") {
                                        html += '<tr><td>'+detailArr[j].agreement_no+'</td><td>'+detailArr[j].type+'</td><td>'+ detailArr[j].reading_out_date +'</td><td class="text-right">'+detailArr[j].reading_out+'</td></tr>';
                                    }else if (data.content.flag == "contract") {
                                        html += '<tr><td>'+detailArr[j].contract_code+'</td><td>'+detailArr[j].type+'</td><td>'+ detailArr[j].reading_out_date +'</td><td class="text-right">'+detailArr[j].reading_out+'</td><td class="text-right">'+detailArr[j].estimate+'</td><td class="text-right">'+detailArr[j].frequency+'</td></tr>';
                                    }
                                }
                            }

                        } else {
                            if (data.content.flag == "invoice") {
                                html += '<tr><td colspan="8">No record found.</td></tr>';
                            }else{
                                if (data.content.flag == "agreement") {
                                    html += '<tr><td colspan="4">No record found.</td></tr>';
                                }else if (data.content.flag == "contract") {
                                    html += '<tr><td colspan="6">No record found.</td></tr>';
                                }else{
                                    html += '<tr><td colspan="4">No record found.</td></tr>';
                                }
                            }
                        }

                        html += '</table></td></tr>';
                        $(html).insertAfter(params.event.target.closest('.clickable'));
                        $(".cb-value").click(function(elm) {
                            var elementId = $(elm.target).attr("id");
                            if (elm.target.checked) {
                                var readVal = $(elm.target).attr("read_value");
                                var sectionVal = $(elm.target).attr("section");
                                var readDateVal = $(elm.target).attr("read_date");
                                var messageVal = "previous";
                                if (sectionVal != null && sectionVal != "") {
                                    if (sectionVal.toLowerCase() == "distance") {
                                        messageVal = "previous Odometer";
                                    }else if (sectionVal.toLowerCase() == "reefer hours") {
                                        messageVal = "previous Reefer";
                                    }else if (sectionVal.toLowerCase() == "engine hours") {
                                        messageVal = "previous Engine";
                                    }
                                }
                                self.$swal({
                                    title: 'Are you sure you want to update '+messageVal+' reading?',
                                    type: 'info',
                                    showCancelButton: true,
                                    confirmButtonText: 'Yes',
                                    cancelButtonText: 'No',
                                    showCloseButton: false,
                                    showLoaderOnConfirm: false
                                }).then((result) => {
                                    if (result.value) {
                                        var readObj = {};
                                        readObj.id = self.currentMileageId;
                                        if (readVal != undefined && readVal != null) {
                                            readObj.reading = readVal;
                                        }
                                        if (sectionVal != undefined && sectionVal != null) {
                                            readObj.section = sectionVal;
                                        }
                                        if (readDateVal != undefined && readDateVal != null) {
                                            readObj.reading_date = readDateVal;
                                        }
                                        readObj.element_id = elementId;
                                        self.updatePreviousData(readObj);
                                    } else {
                                        if (elementId != undefined && elementId != null) {
                                            $('#'+elementId).prop('checked',false);
                                        }
                                    }
                                });
                            }else{
                            }

                        })

                    }
                },
                error: function (jqXHR, exception) {

                    self.reqeustSent = 0;

                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'previous-billed-detail')
                }
            });
        },
        updatePreviousData(previousObj) {
            var self = this;
            if (previousObj != null){
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/mileage-upload-detail/previous-update",
                    type: "POST",
                    data: {id:previousObj.id,reading:previousObj.reading,section:previousObj.section,reading_date:previousObj.reading_date},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $('#'+previousObj.element_id).prop('checked',false);
                        if(data.code == 201){
                            self.$swal('',data.message,'info');
                            return;
                        }
                        if (data.status == "success") {
                            self.$swal('',data.message,'success');
                            self.loadList();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $('#'+previousObj.element_id).prop('checked',false);
                        self.generateStatusCodeMessage(jqXHR, true, 'mileage-upload-update-previous')
                    }
                });
            }
        },
        cancelAll: function (cancelAll) {
          this.$refs.listMileageDetailTable.unselectAllInternal();
        },
    }
}
</script>
<style scoped>
/* for font size in sweet alert */
.swal2-title{
    font-size: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/MileageUploadDetailList.vue